import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthStateService } from '../../core/services/auth-state.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector: 'app-login',
    imports: [FormsModule, RouterLink],
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  private http = inject(HttpClient);
  private authState = inject(AuthStateService);
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  email = '';
  password = '';
  loginError = false;
  loading = false;

  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.queryParamMap.get('logout') === '1' && this.authState.isLoggedIn) {
      await this.authService.logout();
    }
  }

  async login(): Promise<void> {
    this.loginError = false;
    this.loading = true;
    try {
      const res = await firstValueFrom(
        this.http.post<any>(`${environment.apiBaseUrl}/user/auth`, { email: this.email, password: this.password })
      );
      if (res?.success && res.result) {
        this.authState.currentUser = res.result;
        const returnPath = this.authState.returnToPath;
        this.authState.returnToPath = null;
        this.router.navigateByUrl(returnPath ?? '/member');
      } else {
        this.loginError = true;
      }
    } catch {
      this.loginError = true;
    } finally {
      this.loading = false;
    }
  }
}
